import React from "react";
import { Card, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import AllTransactionListing from "./AllTransactionListing";

const Transaction = () => {
  const breadcrumbItems = [
    { title: "Order", link: "" },
    { title: "Transaction", link: "/order/transaction" },
  ];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <AllTransactionListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Transaction;
